<template>
  <div class="columns">
    <div class="column">
      <window title="vue-markdown <a href='https://github.com/miaolz123/vue-markdown' target='_blank'>(more info)">
        <div class="columns">
          <div class="column">
            <textarea v-model="data" class="textarea editor"></textarea>
          </div>
          <div class="column">
            <vue-markdown :source="data" :html="false" class="preview scroll textarea">
            </vue-markdown>
          </div>
        </div>
      </window>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {
  name: 'MarkdownEditor',
  components: {
    VueMarkdown,
  },
  data() {
    return {
      data: `# h1 Heading

Some text and _some italic text_ and more text.

Also **some bold text** and normal text.`,
    };
  },
};
</script>

<style lang="scss" scoped>
.scroll {
  overflow-y: scroll;
}
.section {
  background: white;
  margin: 20px;
}
.editor,
.preview {
  height: 400px;
}
</style>
